import React from "react";

interface QuantityBadgeProps {
  quantity: number;
}

const QuantityBadge: React.FC<QuantityBadgeProps> = (
  props: QuantityBadgeProps
) => {
  const { quantity } = props;
  return (
    <div className="quantity-badge-container">
      <span className="quantity-badge-text">{quantity}</span>
    </div>
  );
};

export default QuantityBadge;
